import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0bd7aefa&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0bd7aefa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd7aefa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bd7aefa')) {
      api.createRecord('0bd7aefa', component.options)
    } else {
      api.reload('0bd7aefa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0bd7aefa&scoped=true&", function () {
      api.rerender('0bd7aefa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/goods-card/index.vue"
export default component.exports